import {Alert} from "@mantine/core";
import { Info as IconInfoCircle } from "@phosphor-icons/react";
import {Row} from "../../../components/Flex/Flex";

export default function FoundTarget ({location}) {
    return (
        <Row justify="center" className="mt-2">
            <Alert color="green" icon={<IconInfoCircle size={16}/>}>{`Target had been located in ${location.name} (${location.galX}, ${location.galY})`}</Alert>
        </Row>
    )
}
